import React, { useState, useEffect } from "react";
import { adminApi } from "../../utils/axiosConfig";
import AllAdmins from "./AllAdmins";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

function AdminUsers() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [me, setMe] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("create"); // 'create' or 'list'

  const superAdminEmail =
    process.env.REACT_APP_EMAIL_ADMIN || "safastep@gmail.com";

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const res = await adminApi.get(`/api/admin/me`);
        setMe(res.data.admin);
      } catch (err) {
        console.error("Non authentifié");
      } finally {
        setIsLoading(false);
      }
    };
    fetchMe();
  }, []);

  const handleCreateAdmin = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email || !password) {
      return setError("Email et mot de passe requis");
    }

    try {
      const res = await adminApi.post(
        `/api/admin/register`,
        { email, password }
      );
      setMessage(res.data.message);
      setEmail("");
      setPassword("");
    } catch (err) {
      const msg = err.response?.data?.message || "Erreur inconnue";
      setError(msg);
    }
  };

  if (isLoading) {
    return (
      <>
        <style>{styles}</style>
        <div className="admin-container">
          <div className="loading-spinner"></div>
        </div>
      </>
    );
  }

  const isSuperAdmin = me?.email === superAdminEmail;

  if (!isSuperAdmin) {
    return (
      <>
        <style>{styles}</style>
        <div className="admin-container">
          <div className="access-denied-card">
            <div className="access-denied-icon">🔒</div>
            <h3>Accès restreint</h3>
            <p>
              Seul l'administrateur principal peut gérer les comptes
              administrateurs.
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{styles}</style>
      <div className="admin-dashboard">
        <div className="admin-header">
          <h1>Gestion des administrateurs</h1>
          <p>Créez et gérez les comptes administrateurs</p>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "create" ? "tab active" : "tab"}
            onClick={() => setActiveTab("create")}
          >
            Créer un administrateur
          </button>
          <button
            className={activeTab === "list" ? "tab active" : "tab"}
            onClick={() => setActiveTab("list")}
          >
            Liste des administrateurs
          </button>
        </div>

        <div className="admin-content">
          {activeTab === "create" && (
            <div className="form-container">
              <div className="admin-card create-admin">
                <h2>Créer un nouvel administrateur</h2>
                <form onSubmit={handleCreateAdmin} className="admin-form">
                  <div className="form-group">
                    <label>Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="email@exemple.com"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Mot de passe</label>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="••••••••"
                      required
                    />
                  </div>
                  <button type="submit" className="submit-btn">
                    Créer le compte
                  </button>
                </form>
                {message && <div className="notification success">{message}</div>}
                {error && <div className="notification error">{error}</div>}
              </div>
            </div>
          )}

          {activeTab === "list" && (
            <div className="admin-card admins-list">
              <h2>Liste des administrateurs</h2>
              <AllAdmins superAdminEmail={superAdminEmail} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const styles = `
  :root {
    --primary: #4361ee;
    --primary-dark: #3a56d4;
    --error: #ef233c;
    --success: #4cc9f0;
    --text: #2b2d42;
    --text-light: #8d99ae;
    --bg: #f8f9fa;
    --card-bg: #ffffff;
    --border-radius: 12px;
    --shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  * {
    box-sizing: border-box;
  }

  body {
    background-color: var(--bg);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
    color: var(--text);
    line-height: 1.6;
    margin: 0;
    padding: 0;
  }

  .admin-dashboard {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    width: 100%;
  }

  .admin-header {
    margin-bottom: 2.5rem;
    text-align: center;
  }

  .admin-header h1 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    color: var(--primary);
  }

  .admin-header p {
    color: var(--text-light);
    font-size: 1rem;
  }

  .admin-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .admin-card {
    background: var(--card-bg);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow);
    padding: 2rem;
    transition: var(--transition);
    width: 100%;
    max-width: 500px;
  }

  .admin-card:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .admin-card h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    color: var(--text);
    position: relative;
    padding-bottom: 0.5rem;
    text-align: center;
  }

  .admin-card h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: var(--primary);
    border-radius: 3px;
  }

  .admin-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .form-group label {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text);
  }

  .form-group input {
    padding: 0.75rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: var(--border-radius);
    font-size: 0.875rem;
    transition: var(--transition);
  }

  .form-group input:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.2);
  }

  .submit-btn {
    padding: 0.75rem 1rem;
    background-color: var(--primary);
    color: white;
    font-weight: 600;
    border: none;
    border-radius: var(--border-radius);
    cursor: pointer;
    transition: var(--transition);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.875rem;
    width: 100%;
  }

  .submit-btn:hover {
    background-color: var(--primary-dark);
    transform: translateY(-2px);
  }

  .notification {
    padding: 0.75rem 1rem;
    border-radius: var(--border-radius);
    font-size: 0.875rem;
    font-weight: 500;
    margin-top: 1rem;
    animation: fadeIn 0.3s ease-in-out;
    text-align: center;
  }

  .success {
    background-color: rgba(76, 201, 240, 0.1);
    color: var(--success);
    border: 1px solid rgba(76, 201, 240, 0.2);
  }

  .error {
    background-color: rgba(239, 35, 60, 0.1);
    color: var(--error);
    border: 1px solid rgba(239, 35, 60, 0.2);
  }

  .access-denied-card {
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    padding: 2rem;
    background: var(--card-bg);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow);
  }

  .access-denied-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: var(--error);
  }

  .access-denied-card h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: var(--text);
  }

  .access-denied-card p {
    color: var(--text-light);
    font-size: 0.875rem;
  }

  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(67, 97, 238, 0.1);
    border-radius: 50%;
    border-top-color: var(--primary);
    animation: spin 1s ease-in-out infinite;
    margin: 2rem auto;
  }

  .tabs {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
    justify-content: center;
  }

  .tab {
    padding: 0.75rem 1.5rem;
    background-color: var(--card-bg);
    border: 1px solid var(--primary);
    border-radius: var(--border-radius);
    cursor: pointer;
    font-weight: 600;
    color: var(--primary);
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .tab:hover {
    background-color: var(--primary);
    color: white;
  }

  .tab.active {
    background-color: var(--primary);
    color: white;
    cursor: default;
  }

  .admins-list {
    max-width: 800px;
    width: 100%;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export default AdminUsers;